import PropTypes from 'prop-types';
import Select from 'react-select';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';

import marketActions from '../../actions/markets';
import WrappedSpinner from './wrapped-spinner';

const styles = {
  marketSelect: {
    zIndex: 103, // TODO perhaps the start of a reason to consolidate some styles
  },
};

function BaseMarketSelect({
  markets, handleChange, marketsLoading, value,
}) {
  const [marketSelections, setMarketSelections] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState('');

  // set up market selections
  useEffect(() => {
    const marketSelectionData = markets.map((market) => ({
      value: market._id,
      label: market.name,
    }));
    setMarketSelections(marketSelectionData);
  }, [markets, marketsLoading]);

  // find selected market from selections when value or selections change
  useEffect(() => {
    const selectionValue = marketSelections.find((selection) => selection.value === value);
    setSelectedMarket(selectionValue);
  }, [value, marketSelections]);

  function handleSelection(newSelection) {
    setSelectedMarket(newSelection);
    handleChange(get(newSelection, 'value'));
  }

  return (
    <WrappedSpinner isLoading={marketsLoading}>
      <Select
        value={selectedMarket}
        onChange={handleSelection}
        isSearchable
        isClearable
        placeholder="Market Select"
        options={marketSelections}
        name="selectedMarket"
        style={styles.marketSelect}
      />
    </WrappedSpinner>
  );
}

BaseMarketSelect.defaultProps = {
  markets: [],
  marketsLoading: false,
  value: '',
};
BaseMarketSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  markets: PropTypes.arrayOf(PropTypes.object),
  marketsLoading: PropTypes.bool,
  value: PropTypes.string,
};

const mapStateToProps = ({ markets }) => ({
  markets: markets.activeMarkets,
  marketsLoading: markets.isLoading,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchActiveMarkets: marketActions.fetchActiveMarkets,
}, dispatch);

const MarketSelect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseMarketSelect);

export { MarketSelect, BaseMarketSelect };
